import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('TransactionStatus').create(({ theme }) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    zIndex: '3',
  },

  buttonWrapper: {
    padding: '0px 12px',
  },

  heading: {
    fontWeight: '450',
    fontSize: '24px',
    lineHeight: '28px',
    textAlign: 'center',
    margin: '0',
    color: theme.colors.text.primary,
  },

  description: {
    fontWight: '350',
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: '17px',
    textAlign: 'center',
    color: theme.colors.text.secondary,
  },

  button: {
    height: theme.sizes.button.height,
    fontSize: theme.sizes.texts.fontSize.m,
    lineHeight: theme.sizes.texts.lineHeight.xl,
    fontWeight: 460,
  },

  glow: {
    '&[data-status="success"]': {
      backgroundColor: theme.colors.text.success,
      content: '""',
      position: 'absolute',
      width: '60%',
      aspectRatio: '1/1',
      top: '-10%',
      left: '50%',
      zIndex: 2,
      transform: 'translate(-50%, -50%)',
      borderRadius: '9999px',
      filter: 'blur(135px)',
    },

    '&[data-status="error"]': {
      backgroundColor: '#e83550',
      content: '""',
      position: 'absolute',
      width: '60%',
      aspectRatio: '1/1',
      top: '-10%',
      left: '50%',
      zIndex: 2,
      transform: 'translate(-50%, -50%)',
      borderRadius: '9999px',
      filter: 'blur(135px)',
    },
  },
}))
